import React, { useState } from 'react';
import { Plus } from 'lucide-react';
import { toast } from 'sonner';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';

const EMPTY = { vendor_name: '', contact_name: '', contact_email: '', contact_phone: '', address_line1: '', city: '', state_province: '', postal_code: '', country: '', payment_terms: '', gst_number: '', lead_time_days: '' };
const FIELDS = [
  ['contact_name', 'Contact Name'], ['contact_phone', 'Phone'], ['contact_email', 'Email', 2], ['address_line1', 'Address', 2],
  ['city', 'City'], ['state_province', 'State / Province'], ['postal_code', 'Postal Code'], ['country', 'Country'],
  ['payment_terms', 'Payment Terms'], ['lead_time_days', 'Lead Time (days)'], ['gst_number', 'GST / HST Reg #', 2],
];

export const QuickAddVendorButton = ({ api, onCreated, disabled }) => {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(EMPTY);
  const [saving, setSaving] = useState(false);

  const save = async () => {
    if (!form.vendor_name.trim()) { toast.error('Vendor name is required'); return; }
    setSaving(true);
    try {
      const payload = Object.fromEntries(Object.entries(form).map(([k, v]) => [k, String(v).trim() || null]));
      payload.lead_time_days = Number(form.lead_time_days) || 0;
      const r = await api().post('/vendors', payload);
      toast.success(`${r.data.vendor_name} added to vendors`);
      onCreated(r.data);
      setForm(EMPTY); setOpen(false);
    } catch (e) { toast.error(e.response?.data?.detail || 'Could not create vendor'); }
    finally { setSaving(false); }
  };

  return (
    <>
      <Button type="button" variant="outline" size="sm" onClick={() => setOpen(true)} disabled={disabled} className="rounded-sm h-9 shrink-0" data-testid="po-quick-add-vendor-btn">
        <Plus className="w-3.5 h-3.5 mr-1" /> New
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-lg" data-testid="po-quick-add-vendor-dialog">
          <DialogHeader><DialogTitle>New Vendor</DialogTitle></DialogHeader>
          <div className="grid grid-cols-2 gap-3">
            <div className="col-span-2"><Label>Vendor Name *</Label><Input value={form.vendor_name} onChange={(e) => setForm({ ...form, vendor_name: e.target.value })} className="rounded-sm" autoFocus data-testid="qav-vendor_name" /></div>
            {FIELDS.map(([k, label, span]) => (
              <div key={k} className={span === 2 ? 'col-span-2' : ''}>
                <Label>{label}</Label>
                <Input type={k === 'lead_time_days' ? 'number' : k === 'contact_email' ? 'email' : 'text'} value={form[k]} onChange={(e) => setForm({ ...form, [k]: e.target.value })} className="rounded-sm" data-testid={`qav-${k}`} />
              </div>
            ))}
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)} className="rounded-sm" data-testid="qav-cancel">Cancel</Button>
            <Button onClick={save} disabled={saving} className="bg-slate-900 hover:bg-slate-800 rounded-sm" data-testid="qav-save">{saving ? 'Saving…' : 'Save & Select'}</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default QuickAddVendorButton;
